import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { RoutePath } from "../../../utility/Constant";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

function SelectionCard({ project, user, handleSingleDelete, dragHandle }) {
  const { selectionContent, selectionContentAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility && (
        <div className="group relative border md:min-h-[20rem] flex flex-col overflow-hidden shadow-lg rounded-lg h-full bg-white">
          {project ? (
            <>
              {/* Image */}
              <figure className="relative">
                {dragHandle && dragHandle}
                <img
                  src={`${process.env.REACT_APP_API_URL}images/${project?.image?.url}`}
                  alt={`${project.title} Image`}
                  className="h-[120px] md:h-[180px] object-cover w-full"
                />
              </figure>


              {/* Content */}
              <div className="p-4 flex flex-col flex-grow justify-between gap-3">
                {/* Title */}
                <h2 className="text-lg font-semibold break-words">
                  {project.title}
                </h2>

                {/* Description */}
                <div className="text-gray-600 break-words">
                  <p className="hidden md:block">
                    {showMore
                      ? project.short_description
                      : `${project.short_description?.substring(0, 100)}...`}
                  </p>
                  <p className="block md:hidden">
                    {showMore
                      ? project.short_description
                      : `${project.short_description?.substring(0, 50)}...`}
                  </p>
                </div>

                {/* Action Section */}
                <div className="flex items-center justify-between mt-3 border-t pt-3">
                  <button
                    onClick={() => setShowMore((prev) => !prev)}
                    className="text-sm text-red-500 hover:text-[#DB0029]"
                  >
                    {project?.short_description?.length > 99 &&
                      (showMore ? "Show less" : "Show more")}
                  </button>

                  <div className="flex gap-2 text-xs md:text-base">
                    <Link
                      to={`/${selectionContent}/${project._id}`}
                      className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 transition duration-150 rounded-lg"
                    >
                      <FaRegEdit size={20} />
                    </Link>
                    {user === "admin" && (
                      <button
                        id={project._id}
                        onClick={handleDelete}
                        className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 transition duration-150 rounded-lg"
                      >
                        <MdDeleteForever size={23} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <Link
              to={`/${selectionContentAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
            >
              <p className="text-8xl group-hover:text-[#DB0029]">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      )}
    </>
  );
}

export default SelectionCard;
